import axios from '../../../../utills/axiosConfig';

export const fetchStoneColors = async (company_code) => {
  const params = {};
  if (company_code) params.company_code = company_code;
  const res = await axios.get('/stone-colors', { params });
  return res.data;
};

export const addStoneColor = async (stoneColor) => {
  try {
    const res = await axios.post('/stone-colors', stoneColor);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const updateStoneColor = async (id, stoneColor) => {
  console.log('API call - Updating stone color:', id, stoneColor);
  const res = await axios.put(`/stone-colors/${id}`, stoneColor);
  console.log('API response:', res.data);
  return res.data;
};

export const deleteStoneColor = async (id) => {
  const res = await axios.delete(`/stone-colors/${id}`);
  return res.data;
};

export const importStoneColorCSV = async (formData) => {
  const { data } = await axios.post('/stone-colors/upload-csv', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
}; 